import {lighten} from 'polished';
import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {Table} from 'components/ui-kit/Table';
import {breakpoint, colors} from 'theme';

export const UserStatusTag = styled.div<{isActive: boolean}>`
    padding: 7px 10px;
    font-size: 11px;
    font-weight: 500;
    border-radius: 4px;
    color: ${(p) => (p.isActive ? colors.success : colors.danger)};
    background-color: ${(p) =>
        p.isActive ? lighten(0.36, colors.success) : lighten(0.25, colors.danger)};
    cursor: default;
    white-space: nowrap;
`;

export const CustomTable = styled(Table)`
    margin-top: -40px;
`;

export const CreateOrganizationButton = styled(Button)`
    width: auto;
    color: ${colors.white};

    > span {
        padding: 0 16px;
    }
`;

export const HeaderControls = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;

    @media (max-width: ${breakpoint.phone}) {
        align-items: stretch;
        flex-direction: column;
    }
`;

export const SearchWrapper = styled.div`
    width: min(100%, 320px);
`;

export const BalanceCell = styled.div`
    width: 100%;
    min-width: 100px;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
`;

export const Cell = styled.div`
    word-break: break-all;
`;
